export default "__VITE_ASSET__CDL$e8pg__"